import { useContext, useMemo } from "react";
import { AuthContext } from "../contexts/AuthContext";

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const useIsAdmin = () => {
  const { user, currentOrganization } = useAuth();
  
  return useMemo(() => {
    if (!user || !currentOrganization) {
      return false;
    }

    // Check if user has Admin role in current organization
    const currentOrgRole = user.userOrganizations?.find(
      uo => uo.organizationId === currentOrganization.id && uo.isActive
    )?.role;

    // Also check global roles array as fallback
    const hasAdminRole = user.roles?.includes('Admin') || currentOrgRole === 'Admin';
    
    return hasAdminRole;
  }, [user, currentOrganization]);
};